
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.271 8.958l-1.322-.173a6.06 6.06 0 000-1.57l1.322-.173a7.418 7.418 0 010 1.916zm-.494-3.765l-1.232.51a5.99 5.99 0 00-.784-1.355l1.057-.812c.388.504.712 1.06.959 1.657zm-2.313-3.011l-.812 1.057a5.993 5.993 0 00-1.356-.784l.511-1.232c.596.247 1.153.57 1.657.959zM8.958.729L8.785 2.05a6.07 6.07 0 00-1.57 0L7.042.729a7.402 7.402 0 011.916 0zm-3.765.494l.51 1.232a5.992 5.992 0 00-1.355.784l-.812-1.057a7.326 7.326 0 011.657-.959zM2.182 3.536l1.057.812a5.992 5.992 0 00-.784 1.356l-1.232-.511c.247-.596.571-1.153.959-1.657zM.729 7.042a7.402 7.402 0 000 1.916l1.322-.173a6.07 6.07 0 010-1.57L.729 7.042zm.494 3.765l1.232-.51c.202.486.466.942.784 1.355l-1.057.812a7.325 7.325 0 01-.959-1.657zm2.313 3.011l.812-1.057a5.99 5.99 0 001.356.784l-.511 1.232a7.331 7.331 0 01-1.657-.959zm3.506 1.453l.173-1.322a6.06 6.06 0 001.57 0l.173 1.322a7.4 7.4 0 01-1.916 0zm3.765-.494l-.51-1.232a5.99 5.99 0 001.355-.784l.812 1.057a7.33 7.33 0 01-1.657.959zm3.011-2.313l-1.057-.812a5.99 5.99 0 00.784-1.356l1.232.511a7.327 7.327 0 01-.959 1.657z","fill":"#000"}})])
          )
        }
      }
    